/**
 * Constants which should be used at aggregator to sent right order type into the core system. It
 * can be user just at the places where we can communicate with core api to overwrite our `OrderType`
 * Please note that for should not use this constants in internal methods, classes etc. just in
 * pleases where it actually needed
 */
export enum DeliveryType {
  Both = "b",
  PickUp = "p",
  PickUpAddress = "pa",
  PickUpTime = "pt",
  PickUpInside = "pi",
  DeliveryAddress = "da",
  DeliveryTime = "dt",
  Delivery = "d",
  DineIn = "dn",
}
